<template>
  <main class="dashboard user-interventions">
    <div class="container-fluid container-fluid--max">
      <h1 class="d-none">Mes interventions</h1>
      <InterventionsSection title="Vos interventions en attente" :interventions="runningInter" id="opesRunning" />
      <InterventionsSection title="Vos interventions réalisées" :interventions="realizedInter" id="opesRealized" class="mt-4" />
      <InterventionsSection title="Vos interventions clôturées" :interventions="resolvedInter" id="opesResolved" class="mt-4" />
    </div>
  </main>
</template>

<script>
import InterventionsSection from './InterventionsSection'
import { mapGetters } from 'vuex'
import store from '@/store'
import { scrollAnchor } from '@/utils/helpers'

export default {
  name: 'Interventions',
  components: {
    InterventionsSection
  },
  data () {
    return {
      runningInter: [],
      realizedInter: [],
      resolvedInter: []
    }
  },
  computed: {
    ...mapGetters({ interventions: `${store.$appName}/interventions` })
  },
  mounted () {
    scrollAnchor(this.$router)
    this.runningInter = this.interventions.running
    this.realizedInter = this.interventions.realized
    this.resolvedInter = this.interventions.resolved
  }
}
</script>
